import { Dispatch, SetStateAction } from "react";

import { ChatFunctionCall, Function_, FunctionsType, JSONSchema, ToolChoice } from "@/types";

export enum ParametersEditorModeEnum {
  JSON = "json",
  INTERACTIVE = "interactive",
}

export type FunctionDialogTriggerVariant = "default" | "menu-item";

export interface FunctionDialogProps {
  onJSONChange?: (json: JSONSchema) => void;
  onSubmit?: (values: Function_) => void;
  functions: Function_[];
  toolChoice?: ToolChoice;
  setFunctions?: (functions: Function_[]) => void;
  functionCall?: ChatFunctionCall;
  setFunctionCall?: (functionCall: ChatFunctionCall) => void;
  functionsType?: FunctionsType;
  setFunctionsType?: (functionsType: FunctionsType) => void;
  jsonSchema?: JSONSchema | false;
  readonly?: boolean;
  triggerVariant?: FunctionDialogTriggerVariant;
}

export type FunctionDialogContextType = {
  functionCallValue?: string;
  toolChoiceValue?: string;
  isAddingFunction: boolean;
  setIsAddingFunction: (isAddingFunction: boolean) => void;
  editingFunction: Function_ | null;
  setEditingFunction: (function_: Function_ | null) => void;
  isEditing: boolean;
  parameterEditorMode: ParametersEditorModeEnum;
  setParameterEditorMode: Dispatch<SetStateAction<ParametersEditorModeEnum>>;
  isShowingBuiltInTools: boolean;
  setIsShowingBuiltInTools: (isShowingBuiltInTools: boolean) => void;
  isShowingMcpTool: boolean;
  setIsShowingMcpTool: (isShowingMcpTool: boolean) => void;
  isShowingRegistryTools: boolean;
  setIsShowingRegistryTools: (isShowingRegistryTools: boolean) => void;
  aiAssistantPortalContainer?: HTMLElement | null;
} & FunctionDialogProps;

export type FunctionFormValues = Function_ & {
  json: Function_;
};
